import { Fragment, useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import logo from  '../../assets/images/logoRecibeVerde.png';
import { Stack } from "../FormControls/Stack";
import { ScreenRouter } from "./ScreenRouter";
import { useCallback } from "react";
import { useSidebarStyles } from "../../styles/sidebar";

export const App = () => {
  const [c, setCoockie, removeCookie] = useCookies();
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });

  const classes = useSidebarStyles();
  const handleWindowResize = () =>
    setDimensions({ height: window.innerHeight, width: window.innerWidth });

  const clearCoockies = useCallback(() => {
    const url = new URLSearchParams(new URL(window.location.href).search);
    setCoockie("Store", url.get("Store"));
    removeCookie("PHPSESSID");
    removeCookie("coincaex");
    removeCookie("token");
    removeCookie("type");
    removeCookie("u");
  }, [removeCookie, setCoockie]);

  useEffect(() => {
    clearCoockies();
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, [clearCoockies]);

  return (
    <>
      {/* LOGO */}
      <div style={{ display: 'flex', justifyContent: 'center', flexShrink: 0 }}>
        <img
          src={logo}
          alt="logo"
          style={{ maxWidth: '10em', margin: '-1em 0 -0.5em 0' }}
        />
      </div>

      {/* CONTAINER WHITE */}
      <div
        style={{
          flex: 1,
          backgroundColor: '#f9f9f9',
          borderTopLeftRadius: '2rem',
          borderTopRightRadius: '2rem',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
        }}
      >
        <div style={{ flex: 1, overflowY: 'auto', padding: '1rem' }}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flex: 1,
              maxWidth: "100%",
            }}
          >
            <Stack
              flex={{
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              style={{ maxWidth: "450px", width: "100%" }}
            >
              {/* <Header /> */}
              <ScreenRouter key={0} />
            </Stack>
          </div>
        </div>
      </div>
    </>
  );
};
